import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "./router";
import App from "./App.vue";
import "./assets/base.css";

// Fix mobile 100vh issues (browser chrome alters innerHeight)
function setVh() {
  if (typeof window === "undefined") return;
  document.documentElement.style.setProperty(
    "--vh",
    `${window.innerHeight * 0.01}px`,
  );
}
setVh();
window.addEventListener("resize", setVh, { passive: true });
window.addEventListener("orientationchange", setVh);
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) setVh();
});

createApp(App).use(createPinia()).use(router).mount("#app");
